import { Segment, Booking } from "../../state/models";

export function isDomesticFlight(segment: Segment): boolean {

  const airport = "MCT"
  if(!segment || segment.stops > 0) return false;

  return segment.originCode === airport || segment.destinationCode === airport;
}

export function getLastFlightDate(booking: Booking): Date | null {
  let segments = booking?.segments;
  if (!segments || !segments.length) return null;

  segments = segments.filter((x) => x); // filter out null segment
  const flight = segments[segments.length - 1];
  let date = Date.parse(flight.departureDate);
  if (Number.isNaN(date)) return null;
  return new Date(date);
};
